/* Monte seu patuá: escolha da corrente e de até 3 pingentes, com soma do preço e compra de tudo junto. */
(function () {
  var D = window.RIPATUA;
  if (!D) return;
  var banho = 'ouro';
  var escolhidos = []; // { p: índice do pingente, v: índice da variante }
  var $ = function (id) { return document.getElementById(id); };
  var lista = $('ri-pingentes'), pend = $('ri-pendurados'), vazio = $('ri-vazio');
  var total = $('ri-total'), qtd = $('ri-qtd'), add = $('ri-add'), fio = $('ri-fio'), erro = $('ri-erro');
  var V = D.visual || {}, imgC = $('ri-corrente-img');
  var tracos = {}; // por endereço da foto da corrente: curva medida na própria foto
  var traco = null, rodada = 0, medidaFalhou = false;
  if (!lista || !fio) return;

  // medidas já calculadas das fotos (corrente e pingentes): servem de base em qualquer aparelho, mesmo onde o navegador não deixa ler os pixels (ex.: navegador interno do Instagram). Fotos novas, com outro nome de arquivo, são medidas na hora.
  var GEO = {"ped":{"Editedimage_1775584858693.png":{"bw":0.2364,"alt":0.7227,"rx":0.4898,"y0":0.1364},"Editedimage_1775680783118_529fdc61-33dc-4794-b481-f1c754c65668.png":{"bw":0.2318,"alt":0.7182,"rx":0.4897,"y0":0.1409},"Produtos_site_31.jpg":{"bw":0.3409,"alt":0.5,"rx":0.5012,"y0":0.2591},"Produtos_site_32.jpg":{"bw":0.3227,"alt":0.4773,"rx":0.5001,"y0":0.2682},"8e44f4_e5650cf1061e45f8b198173a411df193_mv2.webp":{"bw":0.3636,"alt":0.5273,"rx":0.4999,"y0":0.2364},"8e44f4_3730e1ea59de44459415d17703f9134b_mv2_1.webp":{"bw":0.3864,"alt":0.5591,"rx":0.5013,"y0":0.2227},"8_65c812e9-c601-4a2f-922a-643447337dbf.jpg":{"bw":0.5727,"alt":0.7182,"rx":0.5018,"y0":0.1409},"8.jpg":{"bw":0.5773,"alt":0.7227,"rx":0.5015,"y0":0.1409},"9_f86887a8-680e-43b2-86aa-0b0e0ba0d45f.jpg":{"bw":0.4409,"alt":0.7182,"rx":0.496,"y0":0.1409},"9.jpg":{"bw":0.4364,"alt":0.7182,"rx":0.4962,"y0":0.1409},"26.jpg":{"bw":0.3727,"alt":0.5773,"rx":0.5163,"y0":0.2136},"27.jpg":{"bw":0.3727,"alt":0.5682,"rx":0.5165,"y0":0.2182},"pin_tm_banho_de_ouro_novo.jpg":{"bw":0.2273,"alt":0.6591,"rx":0.496,"y0":0.2136},"Produtos_site_28.jpg":{"bw":0.2273,"alt":0.6455,"rx":0.4987,"y0":0.2182},"Produtos_site_29.jpg":{"bw":0.4364,"alt":0.7273,"rx":0.4952,"y0":0.2045},"Produtos_site_30.jpg":{"bw":0.4455,"alt":0.7455,"rx":0.4947,"y0":0.2136}},"cor":{"Produtos_site_4.png":{"asp":1,"x0":0,"x1":1,"eixo":0.50777,"ex":0.50777,"ys":[0.0575,0.0625,0.0675,0.0725,0.0775,0.0825,0.0925,0.1,0.1125,0.1225,0.125,0.13,0.13,0.135,0.1375,0.14,0.1425,0.1475,0.15,0.155,0.1575,0.1625,0.17,0.175,0.1825,0.1875,0.1975,0.205,0.215,0.22,0.225,0.2275,0.2275,0.23,0.235,0.2375,0.24,0.245,0.2475,0.25,0.255,0.26,0.265,0.27,0.2725,0.28,0.285,0.2925,0.3,0.3075,0.315,0.32,0.3225,0.325,0.3275,0.3275,0.3325,0.335,0.3375,0.34,0.3425,0.3475,0.35,0.3525,0.3575,0.3625,0.37,0.375,0.38,0.3875,0.3925,0.4,0.405,0.41,0.4125,0.415,0.4175,0.42,0.4225,0.425,0.4275,0.43,0.4325,0.435,0.44,0.4425,0.4475,0.4525,0.455,0.46,0.465,0.47,0.4775,0.4825,0.4925,0.495,0.5,0.5025,0.5025,0.505,0.5075,0.51,0.51,0.515,0.5175,0.52,0.5225,0.525,0.53,0.5325,0.535,0.54,0.5425,0.5475,0.5525,0.5575,0.5625,0.5675,0.5725,0.58,0.5825,0.5875,0.59,0.59,0.5925,0.595,0.5975,0.6,0.6025,0.6025,0.605,0.6075,0.61,0.615,0.6175,0.62,0.6225,0.6275,0.63,0.635,0.6375,0.6425,0.6475,0.65,0.655,0.66,0.6675,0.67,0.675,0.675,0.6775,0.6775,0.68,0.6825,0.6825,0.685,0.6875,0.69,0.6925,0.695,0.6975,0.7,0.7025,0.7075,0.71,0.7125,0.7175,0.72,0.725,0.7275,0.73,0.735,0.74,0.745,0.7475,0.7525,0.7525,0.755,0.7575,0.7575,0.76,0.76,0.7625,0.7625,0.765,0.7675,0.7675,0.77,0.77,0.7725,0.775,0.7775,0.78,0.7825,0.785,0.785,0.7875,0.79,0.7925,0.795,0.795,0.7975,0.8,0.8,0.8,0.8,0.7975,0.795,0.795,0.7925,0.79,0.7875,0.7875,0.785,0.7825,0.7825,0.78,0.78,0.7775,0.7775,0.7775,0.775,0.775,0.7725,0.7725,0.77,0.77,0.77,0.7675,0.7625,0.76,0.7575,0.7525,0.75,0.745,0.74,0.7375,0.7325,0.73,0.7275,0.725,0.7225,0.72,0.7175,0.715,0.7125,0.71,0.7075,0.7075,0.705,0.7025,0.7,0.6975,0.6975,0.695,0.6925,0.69,0.685,0.68,0.675,0.67,0.665,0.66,0.655,0.6475,0.645,0.6425,0.6375,0.635,0.6325,0.63,0.6275,0.625,0.6225,0.62,0.6175,0.615,0.6125,0.61,0.6075,0.605,0.6025,0.6,0.5975,0.5925,0.5875,0.58,0.575,0.57,0.5625,0.5575,0.555,0.5525,0.5475,0.545,0.54,0.5375,0.535,0.5325,0.53,0.5275,0.525,0.5225,0.52,0.5175,0.515,0.5125,0.5075,0.505,0.5,0.495,0.49,0.48,0.475,0.4675,0.4625,0.46,0.455,0.4525,0.4475,0.445,0.4425,0.4375,0.435,0.4325,0.43,0.4275,0.425,0.4225,0.42,0.4175,0.4125,0.4075,0.3975,0.3925,0.3825,0.3775,0.3725,0.3675,0.3625,0.3575,0.355,0.3525,0.3475,0.345,0.3425,0.3375,0.335,0.3325,0.33,0.3275,0.325,0.32,0.3175,0.31,0.3,0.29,0.285,0.2775,0.2725,0.27,0.2625,0.26,0.255,0.2525,0.25,0.245,0.2425,0.24,0.2375,0.2325,0.23,0.2275,0.2225,0.22,0.21,0.2025,0.195,0.1875,0.18,0.175,0.1675,0.165,0.16,0.155,0.1525,0.15,0.145,0.1425,0.14,0.135,0.1325,0.13,0.125,0.12,0.105,0.0975,0.0875,0.0825,0.0775]},"Produtos_site_7.png":{"asp":1,"x0":0,"x1":1,"eixo":0.50526,"ex":0.50526,"ys":[0.055,0.0575,0.06,0.065,0.0675,0.0725,0.075,0.08,0.085,0.09,0.0975,0.11,0.1175,0.13,0.135,0.1375,0.1425,0.145,0.1475,0.15,0.1525,0.155,0.16,0.1625,0.165,0.17,0.175,0.18,0.1875,0.195,0.2025,0.215,0.2225,0.23,0.2325,0.235,0.2375,0.2425,0.245,0.2475,0.25,0.2525,0.255,0.26,0.2625,0.2675,0.2725,0.2775,0.2825,0.2875,0.2925,0.3025,0.31,0.3175,0.325,0.3275,0.33,0.3325,0.335,0.3375,0.3425,0.345,0.3475,0.35,0.3525,0.355,0.36,0.3625,0.3675,0.375,0.38,0.385,0.3925,0.4,0.4075,0.4125,0.4175,0.42,0.4225,0.425,0.4275,0.43,0.4325,0.435,0.4375,0.4425,0.445,0.4475,0.4525,0.455,0.46,0.465,0.47,0.475,0.48,0.4875,0.495,0.5025,0.505,0.51,0.51,0.5125,0.515,0.5175,0.52,0.5225,0.525,0.5275,0.53,0.5325,0.5375,0.54,0.5425,0.5475,0.55,0.555,0.56,0.5675,0.5725,0.58,0.585,0.59,0.595,0.5975,0.6,0.6025,0.605,0.6075,0.61,0.61,0.6125,0.6175,0.6175,0.62,0.625,0.6275,0.63,0.6325,0.6375,0.64,0.645,0.65,0.655,0.66,0.665,0.6675,0.6725,0.68,0.685,0.6875,0.69,0.6925,0.6925,0.695,0.695,0.6975,0.7,0.7025,0.705,0.71,0.71,0.715,0.7175,0.72,0.725,0.7275,0.73,0.735,0.74,0.7425,0.7475,0.7525,0.7575,0.7625,0.765,0.77,0.7725,0.7725,0.775,0.775,0.7775,0.7775,0.78,0.7825,0.785,0.785,0.7875,0.79,0.79,0.7925,0.795,0.7975,0.8,0.8025,0.805,0.8075,0.81,0.8125,0.815,0.815,0.8175,0.82,0.8225,0.8225,0.82,0.82,0.8175,0.8175,0.815,0.8125,0.81,0.8075,0.8075,0.805,0.8025,0.8025,0.8,0.8,0.7975,0.7975,0.795,0.795,0.7925,0.7925,0.79,0.79,0.79,0.7875,0.785,0.78,0.7775,0.7725,0.7675,0.765,0.76,0.755,0.7525,0.7475,0.745,0.7425,0.74,0.7375,0.735,0.73,0.73,0.7275,0.725,0.7225,0.72,0.7175,0.7175,0.715,0.7125,0.71,0.7075,0.705,0.7,0.695,0.6875,0.6825,0.675,0.67,0.6675,0.6625,0.6575,0.655,0.6525,0.6475,0.645,0.6425,0.64,0.6375,0.635,0.6325,0.63,0.6275,0.625,0.6225,0.62,0.6175,0.615,0.6125,0.605,0.5975,0.59,0.585,0.58,0.5725,0.57,0.5675,0.5625,0.56,0.555,0.5525,0.55,0.5475,0.5425,0.54,0.5375,0.535,0.5325,0.53,0.5275,0.525,0.5225,0.5175,0.5125,0.505,0.495,0.49,0.4825,0.4775,0.4725,0.4675,0.465,0.4625,0.4575,0.455,0.4525,0.45,0.4475,0.445,0.44,0.44,0.435,0.4325,0.43,0.4225,0.415,0.4075,0.4,0.3925,0.3875,0.3825,0.3775,0.3725,0.37,0.365,0.3625,0.36,0.3575,0.3525,0.35,0.3475,0.345,0.3425,0.3375,0.335,0.33,0.3225,0.315,0.305,0.2975,0.29,0.285,0.28,0.275,0.2725,0.2675,0.265,0.2625,0.2575,0.255,0.2525,0.25,0.245,0.2425,0.24,0.235,0.225,0.2125,0.2075,0.2,0.1925,0.1875,0.1825,0.18,0.175,0.17,0.1675,0.165,0.16,0.1575,0.155,0.1525,0.1475,0.145,0.1375,0.1225,0.115,0.1075,0.1025,0.095,0.09,0.0875,0.0825,0.08,0.075,0.0725,0.0675]}}};
  function arq(u) { return String(u || '').split('?')[0].split('/').pop(); }
  var depuracao = /[?&]ridebug/.test(location.search), logs = [];
  function dbg(m) {
    if (!depuracao) return;
    logs.push(m);
    var el = document.getElementById('ri-debug');
    if (!el) { el = document.createElement('pre'); el.id = 'ri-debug'; el.style.cssText = 'position:fixed;left:0;right:0;bottom:0;max-height:40vh;overflow:auto;margin:0;padding:8px;background:#000c;color:#0f0;font:11px/1.3 monospace;z-index:99999;white-space:pre-wrap'; document.body.appendChild(el); }
    el.textContent = logs.join('\n');
  }

  function brl(c) { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
  function doBanho() {
    var r = [];
    D.pingentes.forEach(function (p, i) { if (p.banho === banho) r.push(i); });
    return r;
  }
  function achar(i) { for (var k = 0; k < escolhidos.length; k++) if (escolhidos[k].p === i) return k; return -1; }
  function disponivel(p) { return p.variantes.some(function (v) { return v.ok; }); }
  function primeiraOk(p) { for (var k = 0; k < p.variantes.length; k++) if (p.variantes[k].ok) return k; return 0; }

  // baixa a foto e entrega como arquivo local (blob): assim o navegador sempre deixa medir os pixels, em qualquer aparelho e mesmo na primeira visita
  var blobs = {};
  function buscar(src) {
    if (blobs[src]) return blobs[src];
    blobs[src] = new Promise(function (res) {
      if (!window.fetch || !window.URL || !window.Blob) return res(null);
      fetch(src, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw 0; return r.blob(); })
        .then(function (b) { res(URL.createObjectURL(b)); })
        .catch(function () { res(null); });
    });
    return blobs[src];
  }
  function carregar(img, src, depois) {
    var tentouSem = false;
    img.onload = function () { if (depois) depois(img); };
    img.onerror = function () {
      if (tentouSem) { if (img.onfalha) img.onfalha(); return; }
      tentouSem = true;
      img.removeAttribute('crossorigin');
      img.src = src;
    };
    buscar(src).then(function (url) {
      if (url) img.src = url; else { img.crossOrigin = 'anonymous'; img.src = src; }
    });
  }

  // ---- tom do banho de ouro: todas as peças douradas ficam no mesmo tom da Concha (referência) ----
  var tons = {}, tomUrl = {}, refP = null;
  function paraHsv(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn, h = 0;
    if (d) { if (mx === r) h = ((g - b) / d) % 6; else if (mx === g) h = (b - r) / d + 2; else h = (r - g) / d + 4; h *= 60; if (h < 0) h += 360; }
    return [h, mx ? d / mx : 0, mx];
  }
  function paraRgb(h, s, v) {
    var c = v * s, x = c * (1 - Math.abs((h / 60) % 2 - 1)), m = v - c, r = 0, g = 0, b = 0;
    if (h < 60) { r = c; g = x; } else if (h < 120) { r = x; g = c; } else if (h < 180) { g = c; b = x; } else if (h < 240) { g = x; b = c; } else if (h < 300) { r = x; b = c; } else { r = c; b = x; }
    return [(r + m) * 255, (g + m) * 255, (b + m) * 255];
  }
  function pesoOuro(h, s, v) {
    var wh = h < 25 || h > 65 ? 0 : h < 30 ? (h - 25) / 5 : h > 60 ? (65 - h) / 5 : 1;
    var ws = Math.min(1, Math.max(0, (s - 0.25) / 0.15)), wv = Math.min(1, Math.max(0, (v - 0.25) / 0.1));
    return wh * ws * wv;
  }
  function lerTom(d) {
    var n = 0, H = 0, S = 0, Vv = 0;
    for (var k = 0; k < d.length; k += 4) {
      if (d[k + 3] < 200) continue;
      var q = paraHsv(d[k], d[k + 1], d[k + 2]);
      if (pesoOuro(q[0], q[1], q[2]) > 0.99) { n++; H += q[0]; S += q[1]; Vv += q[2]; }
    }
    return n ? { n: n, h: H / n, s: S / n, v: Vv / n } : null;
  }
  function referencia() {
    if (refP) return refP;
    refP = new Promise(function (res) {
      var c = null;
      D.pingentes.forEach(function (p) { if (!c && p.banho === 'ouro' && p.nome.indexOf('Concha') === 0) c = p; });
      if (!c) return res(null);
      var im = new Image();
      im.onload = function () { try { var t = lerTom(pixels(im, 300).d); res(t && t.n > 200 ? t : null); } catch (e) { res(null); } };
      im.onerror = function () { res(null); };
      buscar(c.img).then(function (u) { if (u) im.src = u; else res(null); });
    });
    return refP;
  }
  function comTom(src) {
    if (tons[src]) return tons[src];
    tons[src] = referencia().then(function (ref) {
      if (!ref) return null;
      return new Promise(function (res) {
        var im = new Image();
        im.onload = function () {
          try {
            var P = pixels(im, 1400), d = P.d, t = lerTom(d);
            if (!t || t.n < 50) return res(null);
            var dh = Math.max(-15, Math.min(15, ref.h - t.h)), gs = Math.max(0.7, Math.min(1.3, ref.s / t.s)), gv = Math.max(0.8, Math.min(1.3, ref.v / t.v));
            for (var k = 0; k < d.length; k += 4) {
              if (d[k + 3] === 0) continue;
              var q = paraHsv(d[k], d[k + 1], d[k + 2]), w = pesoOuro(q[0], q[1], q[2]);
              if (w <= 0) continue;
              var rgb = paraRgb((q[0] + w * dh + 360) % 360, Math.min(1, q[1] * (1 + w * (gs - 1))), Math.min(1, q[2] * (1 + w * (gv - 1))));
              d[k] = rgb[0]; d[k + 1] = rgb[1]; d[k + 2] = rgb[2];
            }
            var c = document.createElement('canvas'); c.width = P.w; c.height = P.h;
            var x = c.getContext('2d'); x.putImageData(new ImageData(d, P.w, P.h), 0, 0);
            c.toBlob(function (b) { if (!b) return res(null); tomUrl[src] = URL.createObjectURL(b); res(tomUrl[src]); }, 'image/png');
          } catch (e) { res(null); }
        };
        im.onerror = function () { res(null); };
        buscar(src).then(function (u) { if (u) im.src = u; else res(null); });
      });
    });
    return tons[src];
  }
  // troca a imagem pela versão no tom certo (só banho de ouro) e avisa quando terminar
  function aplicarTom(img, src, depois) {
    if (banho !== 'ouro') return depois();
    comTom(src).then(function (url) {
      if (!url) return depois();
      img.onerror = null;
      img.onload = function () { img.onload = null; depois(); };
      img.src = url;
    });
  }

  function pixels(img, larg) {
    var w = Math.min(larg, img.naturalWidth), h = Math.max(1, Math.round(img.naturalHeight * w / img.naturalWidth));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, w, h);
    return { w: w, h: h, d: x.getImageData(0, 0, w, h).data };
  }

  // mede o desenho do pingente (sem as margens da foto) para todos ficarem com o mesmo tamanho visual
  function medidaPed(img, src) {
    var g = GEO.ped[arq(src)];
    if (g) { dbg('pingente ' + arq(src) + ': medida pronta'); return g; }
    try {
      var P = pixels(img, 220), w = P.w, h = P.h, d = P.d;
      var x0 = w, x1 = -1, y0 = h, y1 = -1;
      for (var y = 0; y < h; y++) for (var i = 0; i < w; i++) {
        var o = (y * w + i) * 4;
        if (d[o + 3] > 40 && Math.min(d[o], d[o + 1], d[o + 2]) < 225) {
          if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y;
        }
      }
      if (x1 < 0) throw 0;
      // posição da argola (parte de cima do desenho): é ela que fica presa na corrente, não o centro da peça
      var yb = y0 + Math.max(2, Math.round((y1 - y0) * 0.08)), sx = 0, sn = 0;
      for (var yr = y0; yr <= yb; yr++) for (var xr = x0; xr <= x1; xr++) {
        var orr = (yr * w + xr) * 4;
        if (d[orr + 3] > 40 && Math.min(d[orr], d[orr + 1], d[orr + 2]) < 225) { sx += xr; sn++; }
      }
      var rx = sn ? (sx / sn + 0.5) : (x0 + x1 + 1) / 2;
      var bw = (x1 - x0 + 1) / w, bh = (y1 - y0 + 1) / h;
      dbg('pingente ' + arq(src) + ': medido na hora');
      return { bw: bw, alt: bh * h / w, rx: rx / w, y0: y0 / h };
    } catch (err) { dbg('pingente ' + arq(src) + ': FALHOU a medida'); return null; }
  }
  function dimensionar(img, src) {
    var tam = V.ped_tam || 15, m = medidaPed(img, src);
    if (m) {
      var maior = Math.max(m.bw, m.alt), medio = Math.sqrt(m.bw * m.alt);
      var pct = Math.min(tam / medio, tam * 1.6 / maior);
      img.style.width = pct.toFixed(2) + '%';
      // sobe um pouco, para a argola passar por cima da corrente e envolvê-la
      img.style.marginTop = (-0.045 * m.alt * pend.offsetWidth * pct / 100).toFixed(1) + 'px';
      img.style.transform = 'translate(-' + (m.rx * 100).toFixed(2) + '%,-' + (m.y0 * 100).toFixed(2) + '%)';
      img._w = m.bw * pct / 100 * pend.offsetWidth;
    } else {
      img.style.width = (tam * 1.7).toFixed(2) + '%';
      img.style.transform = 'translate(-50%,-16%)';
      img._w = tam * 1.7 / 100 * pend.offsetWidth * 0.6;
    }
  }

  // acompanha a corrente da foto: para cada ponto da largura, a altura do alto da corrente
  function medirCorrente(img, foto) {
    if (GEO.cor[arq(foto)]) { dbg('corrente ' + arq(foto) + ': medida pronta'); return GEO.cor[arq(foto)]; }
    var P = pixels(img, 400), w = P.w, h = P.h, d = P.d;
    var semFundo = false;
    for (var k = 3; k < d.length; k += 4 * 7) if (d[k] < 250) { semFundo = true; break; }
    var r0 = d[0], g0 = d[1], b0 = d[2];
    function tinta(o) {
      if (semFundo) return d[o + 3] > 70;
      return Math.abs(d[o] - r0) + Math.abs(d[o + 1] - g0) + Math.abs(d[o + 2] - b0) > 90;
    }
    var ys = new Array(w), x0 = -1, x1 = -1;
    for (var x = 0; x < w; x++) {
      ys[x] = -1;
      for (var y = 0; y < h; y++) if (tinta((y * w + x) * 4)) { ys[x] = y / h; break; }
      if (ys[x] >= 0) { if (x0 < 0) x0 = x; x1 = x; }
    }
    if (x0 < 0 || x1 - x0 < w * 0.2) throw 0;
    // espessura típica da corrente (para pendurar no meio do fio, não na borda de cima)
    var runs = [];
    for (var xx = x0; xx <= x1; xx += 2) {
      if (ys[xx] < 0) continue;
      var yy = Math.round(ys[xx] * h), n = 0;
      while (yy + n < h && tinta(((yy + n) * w + xx) * 4)) n++;
      runs.push(n);
    }
    runs.sort(function (a, b) { return a - b; });
    var esp = runs.length ? runs[Math.floor(runs.length / 2)] / h : 0;
    // fecha pequenos buracos (elos da corrente)
    var ult = -1;
    for (var j = x0; j <= x1; j++) {
      if (ys[j] >= 0) {
        if (ult >= 0 && j - ult > 1) for (var q = ult + 1; q < j; q++) ys[q] = ys[ult] + (ys[j] - ys[ult]) * (q - ult) / (j - ult);
        ult = j;
      }
    }
    // eixo de simetria da corrente: onde o lado esquerdo e o direito se espelham melhor (o meio de verdade, mesmo que a foto esteja torta)
    var sp = x1 - x0, melhor = 1e9, ax = (x0 + x1) / 2;
    for (var cc = x0 + sp * 0.4; cc <= x0 + sp * 0.6; cc += 0.5) {
      var er = 0, cn = 0;
      for (var dd = sp * 0.05; dd <= sp * 0.45; dd += 1) {
        var le = cc - dd, ri = cc + dd;
        if (le < x0 || ri > x1) break;
        var df = ys[Math.round(le)] - ys[Math.round(ri)];
        er += df * df; cn++;
      }
      if (cn > 5 && er / cn < melhor) { melhor = er / cn; ax = cc; }
    }
    dbg('corrente ' + arq(foto) + ': medida na hora');
    return { asp: h / w, x0: x0 / (w - 1), x1: x1 / (w - 1), ys: ys, t: Math.min(esp, 0.06), eixo: (ax - x0) / sp, ex: ax / (w - 1) };
  }

  // coloca a foto da corrente de modo que o meio dela fique no meio do círculo, mesmo se a foto estiver descentralizada
  function posFoto() {
    if (!imgC) return;
    if (traco && !imgC.hidden && imgC.offsetWidth) {
      var W = imgC.offsetWidth / pend.offsetWidth * 100;
      imgC.style.left = (50 - traco.ex * W).toFixed(2) + '%';
      imgC.style.transform = 'none';
    } else if (!foto_atual()) { imgC.style.left = ''; imgC.style.transform = ''; }
  }
  function foto_atual() { return banho === 'ouro' ? V.img_ouro : V.img_prata; }

  function ancora(f, box) {
    // medidas de layout (offset*) e não as da tela: não mudam durante animações de entrada da página
    var ajuste = (V.ped_ajuste || 0) / 100 * pend.offsetHeight, esc = (box.width / pend.offsetWidth) || 1;
    if (traco && imgC && !imgC.hidden && imgC.offsetWidth) {
      // a altura vem da proporção da foto (e não da altura na tela, que fica zerada por instantes quando a foto está sendo trocada)
      var r = { left: imgC.offsetLeft, top: imgC.offsetTop, width: imgC.offsetWidth, height: imgC.offsetWidth * traco.asp };
      var xf = traco.x0 + f * (traco.x1 - traco.x0);
      var col = Math.min(traco.ys.length - 1, Math.max(0, Math.round(xf * (traco.ys.length - 1))));
      var yf = traco.ys[col];
      if (yf >= 0) return { x: r.left + xf * r.width, y: r.top + yf * r.height + ajuste };
    }
    var L = fio.getTotalLength(), svg = fio.ownerSVGElement.getBoundingClientRect(), pt = fio.getPointAtLength(L * f);
    return { x: ((pt.x / 600) * svg.width + (svg.left - box.left)) / esc, y: ((pt.y / 300) * svg.height + (svg.top - box.top)) / esc + ajuste };
  }

  function desenharLista() {
    lista.innerHTML = '';
    doBanho().forEach(function (i) {
      var p = D.pingentes[i], k = achar(i), on = k >= 0;
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-pressed', on);
      b.disabled = !disponivel(p) || (!on && escolhidos.length >= 3);
      var preco = p.variantes[on ? escolhidos[k].v : primeiraOk(p)].preco;
      b.innerHTML = '<img src="' + (tomUrl[p.img] || p.img) + '" alt="" loading="lazy"><span class="ri-pn"></span><span class="ri-pp">' + (disponivel(p) ? brl(preco) : 'Esgotado') + '</span>';
      b.querySelector('.ri-pn').textContent = p.nome;
      b.addEventListener('click', function () {
        var j = achar(i);
        if (j >= 0) escolhidos.splice(j, 1);
        else if (escolhidos.length < 3) escolhidos.push({ p: i, v: primeiraOk(p) });
        atualizar();
      });
      if (banho === 'ouro' && !tomUrl[p.img]) comTom(p.img).then(function (url) { var im = b.querySelector('img'); if (url && im) im.src = url; });
      li.appendChild(b);
      // pingente com mais de uma opção (ex.: pedra da Água Viva)
      if (on && p.variantes.length > 1) {
        var sel = document.createElement('select');
        sel.setAttribute('aria-label', 'Opção do pingente ' + p.nome);
        p.variantes.forEach(function (v, n) {
          var o = document.createElement('option');
          o.value = n; o.textContent = v.nome + (v.ok ? '' : ' (esgotado)'); o.disabled = !v.ok;
          if (n === escolhidos[k].v) o.selected = true;
          sel.appendChild(o);
        });
        sel.addEventListener('change', function () { escolhidos[achar(i)].v = +sel.value; atualizar(); });
        li.appendChild(sel);
      }
      lista.appendChild(li);
    });
  }

  function desenharVitrine() {
    pend.innerHTML = '';
    var token = ++rodada;
    // com 3 pingentes, a Água Viva vai sempre para o centro
    var ordem = escolhidos.slice();
    if (ordem.length === 3) {
      var m = -1;
      ordem.forEach(function (en, k) { if (D.pingentes[en.p].nome.indexOf('Água Viva') === 0) m = k; });
      if (m >= 0 && m !== 1) { var c = ordem.splice(m, 1)[0]; ordem.splice(1, 0, c); }
    }
    var box = pend.getBoundingClientRect(), imgs = [], falta = ordem.length;
    ordem.forEach(function (en) {
      var img = document.createElement('img');
      img.alt = 'Pingente ' + D.pingentes[en.p].nome;
      img.style.visibility = 'hidden';
      pend.appendChild(img);
      imgs.push(img);
      carregar(img, D.pingentes[en.p].img, function (i) {
        dimensionar(i, D.pingentes[en.p].img);
        aplicarTom(i, D.pingentes[en.p].img, function () { if (token === rodada && --falta === 0) colocar(imgs, box); });
      });
    });
    vazio.hidden = escolhidos.length > 0;
  }

  // espaça os pingentes pela largura de cada um: o do meio no centro da corrente, os outros ao lado, na mesma distância
  function colocar(imgs, box) {
    var n = imgs.length;
    if (!n) return;
    // enquanto a foto da corrente não foi medida, os pingentes esperam (não são colocados num lugar provisório)
    if (foto_atual() && !traco && !medidaFalhou) return;
    var span;
    if (traco && imgC && !imgC.hidden && imgC.offsetWidth) span = (traco.x1 - traco.x0) * imgC.offsetWidth;
    else span = fio.ownerSVGElement.getBoundingClientRect().width * 0.96 / ((box.width / pend.offsetWidth) || 1);
    var gap = (V.ped_espaco || 22) / 100 * span * 0.35;
    var w = imgs.map(function (i) { return i._w || 0; });
    // argolas sempre simétricas em relação ao centro da corrente
    var D2 = n === 3 ? Math.max(w[1] / 2 + gap + w[0] / 2, w[1] / 2 + gap + w[2] / 2) : gap / 2 + Math.max(w[0], w[1] || 0) / 2;
    var off = n === 1 ? [0] : n === 2 ? [-D2, D2] : [-D2, 0, D2];
    imgs.forEach(function (img, k) {
      var f = Math.min(0.98, Math.max(0.02, (traco && imgC && !imgC.hidden && imgC.offsetWidth ? traco.eixo : 0.5) + off[k] / span));
      var a = ancora(f, box);
      img.style.left = a.x + 'px';
      img.style.top = a.y + 'px';
      img.style.visibility = 'visible';
    });
  }

  // cor do desenho e foto da corrente (se houver) para cada acabamento; o desenho fica invisível, mas ocupa o mesmo lugar, para os pingentes acompanharem a curva
  function pintarCorrente() {
    var cor = banho === 'ouro' ? (V.cor_ouro || '#B08D4C') : (V.cor_prata || '#9AA3A9');
    var foto = banho === 'ouro' ? V.img_ouro : V.img_prata;
    fio.style.stroke = cor;
    traco = null;
    if (imgC) {
      if (foto) {
        imgC.hidden = false;
        if (imgC.getAttribute('data-src') !== foto) {
          imgC.setAttribute('data-src', foto);
          imgC.onfalha = function () { medidaFalhou = true; desenharVitrine(); };
          carregar(imgC, foto, function () {
            try { tracos[foto] = tracos[foto] || medirCorrente(imgC, foto); traco = tracos[foto]; } catch (err) { traco = null; medidaFalhou = true; dbg('corrente: FALHOU a medida'); }
            posFoto();
            desenharVitrine();
            if (banho === 'ouro') comTom(foto).then(function (url) { if (url && imgC.getAttribute('data-src') === foto && banho === 'ouro') { imgC.onload = null; imgC.onerror = null; imgC.src = url; } });
          });
        } else if (tracos[foto]) { traco = tracos[foto]; posFoto(); }
      } else { imgC.hidden = true; imgC.removeAttribute('src'); imgC.removeAttribute('data-src'); imgC.style.left = ''; imgC.style.transform = ''; }
    }
    fio.ownerSVGElement.style.visibility = foto ? 'hidden' : 'visible';
  }

  function atualizar() {
    pintarCorrente();
    var c = D.correntes[banho];
    var soma = (c ? c.preco : 0) + escolhidos.reduce(function (s, e) { return s + D.pingentes[e.p].variantes[e.v].preco; }, 0);
    total.textContent = brl(soma);
    qtd.textContent = escolhidos.length;
    add.disabled = escolhidos.length === 0 || !c || !c.ok;
    desenharLista(); desenharVitrine();
  }

  document.querySelectorAll('.ri-banho button').forEach(function (b) {
    b.addEventListener('click', function () {
      if (banho === b.dataset.banho) return;
      banho = b.dataset.banho;
      document.querySelectorAll('.ri-banho button').forEach(function (x) { x.setAttribute('aria-checked', x === b); });
      escolhidos = [];
      atualizar();
    });
  });

  add.addEventListener('click', function () {
    var c = D.correntes[banho];
    var items = [{ id: c.id, quantity: 1 }].concat(escolhidos.map(function (e) { return { id: D.pingentes[e.p].variantes[e.v].id, quantity: 1 }; }));
    add.disabled = true; erro.hidden = true; add.textContent = 'Adicionando...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw r; window.location.href = '/cart'; })
      .catch(function () { erro.hidden = false; add.disabled = false; add.textContent = 'Adicionar à sacola'; });
  });

  // rede de segurança: se a corrente demorar demais, usa o traço simples
  setTimeout(function () { if (foto_atual() && !traco && !medidaFalhou) { medidaFalhou = true; desenharVitrine(); } }, 6000);
  window.addEventListener('resize', desenharVitrine);
  // refaz o posicionamento quando o tamanho da vitrine muda sozinho (fontes, imagens e animações da página terminando de carregar)
  window.addEventListener('load', desenharVitrine);
  if (window.ResizeObserver) {
    var ult = [pend.offsetWidth, pend.offsetHeight];
    new ResizeObserver(function () {
      var a = pend.offsetWidth, b = pend.offsetHeight;
      if (a !== ult[0] || b !== ult[1]) { ult = [a, b]; desenharVitrine(); }
    }).observe(pend);
  }

  // começa só com a corrente: os pingentes aparecem quando a cliente escolhe
  atualizar();
})();
